import { RootState } from 'redux/schemas';

// eslint-disable-next-line import/prefer-default-export
export const getCourseAccessModalProps = (state: RootState) => state.app.courseAccessModalProps;
